/* eslint-disable @repo/internal/react/no-class-components */
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    const analyticsEvent = this.props.createAnalyticsEvent({
      action: 'handled',
      actionSubject: 'error',
      actionSubjectId: 'remoteModuleErrorBoundary',
      attributes: {
        error: error === null || error === void 0 ? void 0 : error.message,
        errorInfo,
        dimensions: this.props.remotePlugin.dimensions,
        plugin: this.props.remotePlugin.constructor.name
      }
    });
    analyticsEvent.fire(this.props.analyticsChannel);
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
    this.setState({
      hasError: true
    });
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback ? /*#__PURE__*/React.createElement(React.Fragment, null, this.props.fallback) : null;
    }
    return this.props.children;
  }
}
export default withAnalyticsEvents()(ErrorBoundary);